export const errMsg = (e, fallback = "Erreur") => e?.response?.data?.detail || fallback;

export const selectCls =
  "h-10 border border-zinc-900 bg-white px-3 text-sm rounded-none focus:outline-none focus:ring-2 focus:ring-[var(--ny-gold)]";

const STATUS_LABEL = { panne: "Panne", inactif: "Inactif", rendu: "Rendu" };

export const truckFlags = (t) =>
  [
    STATUS_LABEL[t.status],
    t.red_tag && "Red tag",
    t.awaiting_expert && "Att. expert",
  ].filter(Boolean);

export const truckLabel = (t) => [t.license_plate, ...truckFlags(t).map((f) => f.toUpperCase())].join(" · ");

export const normPlate = (s) => (s || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
